module.exports = "<div class=gmc-avatar><div class=\"d-flex justify-content-center align-items-center gmc-avatar__photo\"><img class=\"img-fluid gmc-avatar__pic\" ng-src={{$ctrl.photo}} alt=photo></div><div class=gmc-avatar__indicator ng-if=$ctrl.indicator ng-class=\"{active: $ctrl.active}\"></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-avatar/gmc-avatar.component.html
// module id = 530
// module chunks = 31